import {Component} from '@angular/core';

@Component({
             selector: 'dms-tag',
             templateUrl: './tag.component.html',
             styleUrls: ['./tag.component.css']
           })
export class TagComponent {
}
